import APP from 'locales/en/app.json';
import COMPONENT_PAGE from 'modules/ComponentPage/locales/en/componentPage.json';
import DESIGN_GENERATOR from 'modules/DesignGenerator/locales/en/designGenerator.json';
import EDITOR_ACCESSIBILITY_MENU from 'modules/Editor/components/AccessibilityManager/locales/en/accessibilityMenu.json';
import AUTO_BRAND from 'modules/Editor/components/AutoBrand/locales/en/auto_brand.json';
import EDITOR_COLOR_PICKER from 'modules/Editor/components/ColorPicker/locales/en/colorPicker.json';
import EDITOR_EDIT_BACKGROUND_MENU from 'modules/Editor/components/EditBackgroundMenu/locales/en/editBackgroundMenu.json';
import EDITOR_FLOWMODE from 'modules/Editor/components/FlowCore/locales/en/flowmode.json';
import BRAND_KIT_UPGRADE_MODAL from 'modules/Editor/components/Modals/locales/en/brandKitUpgradeModal.json';
import COPY_PASTE_SHORTCUT_MODAL from 'modules/Editor/components/Modals/locales/en/copyPasteShortcutModal.json';
import ICON_UPGRADE_MODAL from 'modules/Editor/components/Modals/locales/en/iconUpgradeModal.json';
import IMPROVE_TEXT_UPGRADE_MODAL from 'modules/Editor/components/Modals/locales/en/improveTextUpgradeModal.json';
import MAP_CHARTS_UPGRADE_MODAL from 'modules/Editor/components/Modals/locales/en/mapChartsUpgradeModal.json';
import TEMPLATE_UPGRADE_MODAL from 'modules/Editor/components/Modals/locales/en/templateUpgradeModal.json';
import UPGRADE_PREMIUM_MAP_MODAL from 'modules/Editor/components/Modals/locales/en/upgradePremiumMapModal.json';
import COMMON_NAVBAR from 'modules/Editor/components/Navbar/locales/en/navbar.json';
import EDITOR_PAGE_CONTROLS from 'modules/Editor/components/PageControls/locales/en/pageControls.json';
import EDITOR_PAGE_MANAGER from 'modules/Editor/components/PageManager/locales/en/pageManager.json';
import EDITOR_SIDE_MENU_SETTINGS from 'modules/Editor/components/SideMenuSettings/locales/en/sideMenuSettings.json';
import EDITOR_SPREADSHEET from 'modules/Editor/components/Spreadsheet/locales/en/spreadsheet.json';
import EDITOR_TOOLBAR_ALTTEXTMENU from 'modules/Editor/components/Toolbar/AltTextMenu/locales/en/altTextMenu.json';
import EDITOR_TOOLBAR_PAGE_MENU from 'modules/Editor/components/Toolbar/PageMenu/locales/en/pageMenu.json';
import EDITOR_TOOLBAR from 'modules/Editor/components/Toolbar/locales/en/toolbar.json';
import EDITOR_WIDGET_MENU from 'modules/Editor/components/WidgetMenu/locales/en/widgetMenu.json';
import USER from 'modules/User/locales/en/user.json';
import COMMON_COMPONENTS from 'modules/common/components/i18n-resources/en';
import SHAPES_TOOLBAR from 'widgets/BasicShapeWidget/locales/en/toolbar.json';
import CHART_WIDGET from 'widgets/ChartWidgets/locales/en/chart.json';
import ICON_TOOLBAR from 'widgets/IconWidget/locales/en/toolbar.json';
import IMAGE_TOOLBAR from 'widgets/ImageWidget/locales/en/toolbar.json';
import LINE_TOOLBAR from 'widgets/Lines/LineWidget/locales/en/toolbar.json';
import MAP_CHART_TOOLBAR from 'widgets/MapWidget/locales/en/toolbar.json';
import PROGRESS_CHART_TOOLBAR from 'widgets/ProgressChartWidget/locales/en/toolbar.json';
import QR_CODE_TOOLBAR from 'widgets/QRCodeWidget/locales/en/toolbar.json';
import STAT_CHART_TOOLBAR from 'widgets/ResponsiveWidgets/StatChartWidget/locales/en/toolbar.json';
import LABEL_TEXT_TOOLBAR from 'widgets/TextBasedWidgets/LabelTextWidget/locales/en/toolbar.json';
import TABLE_TOOLBAR from 'widgets/TextBasedWidgets/TableWidget/locales/en/toolbar.json';
import TEXT_TOOLBAR from 'widgets/TextBasedWidgets/TextWidget/locales/en/toolbar.json';

const WIDGET_TOOLBAR = {
  progressChartToolbar: PROGRESS_CHART_TOOLBAR,
  labelTextToolbar: LABEL_TEXT_TOOLBAR,
  statChartToolbar: STAT_CHART_TOOLBAR,
  textToolbar: TEXT_TOOLBAR,
  tableToolbar: TABLE_TOOLBAR,
  imageToolbar: IMAGE_TOOLBAR,
  mapChartToolbar: MAP_CHART_TOOLBAR,
  shapesToolbar: SHAPES_TOOLBAR,
  iconToolbar: ICON_TOOLBAR,
  lineToolbar: LINE_TOOLBAR,
  qrCodeToolbar: QR_CODE_TOOLBAR,
};

const MODALS = {
  copyPasteShortcutModal: COPY_PASTE_SHORTCUT_MODAL,
  upgradePremiumMapModal: UPGRADE_PREMIUM_MAP_MODAL,
  iconUpgradeModal: ICON_UPGRADE_MODAL,
  improveTextUpgradeModal: IMPROVE_TEXT_UPGRADE_MODAL,
  mapChartsUpgradeModal: MAP_CHARTS_UPGRADE_MODAL,
  brandKitUpgradeModal: BRAND_KIT_UPGRADE_MODAL,
  templateUpgradeModal: TEMPLATE_UPGRADE_MODAL,
};

// Map resources
export const resources = {
  app: APP,
  design_generator: DESIGN_GENERATOR,
  common_components: COMMON_COMPONENTS,
  common_navbar: COMMON_NAVBAR,
  component_page: COMPONENT_PAGE,
  auto_brand: AUTO_BRAND,
  editor_widget_menu: EDITOR_WIDGET_MENU,
  editor_spreadsheet: EDITOR_SPREADSHEET,
  editor_toolbar: EDITOR_TOOLBAR,
  editor_widget_toolbar: WIDGET_TOOLBAR,
  editor_toolbar_alt_text_menu: EDITOR_TOOLBAR_ALTTEXTMENU,
  editor_toolbar_page_menu: EDITOR_TOOLBAR_PAGE_MENU,
  editor_accessibility_menu: EDITOR_ACCESSIBILITY_MENU,
  editor_color_picker: EDITOR_COLOR_PICKER,
  editor_side_menu_settings: EDITOR_SIDE_MENU_SETTINGS,
  editor_page_manager: EDITOR_PAGE_MANAGER,
  editor_flowmode: EDITOR_FLOWMODE,
  editor_modals: MODALS,
  editor_edit_background_menu: EDITOR_EDIT_BACKGROUND_MENU,
  editor_page_controls: EDITOR_PAGE_CONTROLS,
  chart_widget: CHART_WIDGET,
  user: USER,
} as const;

export default resources;
